document.addEventListener('DOMContentLoaded', async () => {
  const cartModule = document.querySelector('.cart-module');
  const updateProducts = () => {
    const productItems = document.querySelectorAll('.cart-product-list__item');
    const products = [];
    productItems.forEach((item) => {
      const productID = item.getAttribute('data-product_id');
      const productVariation = item.getAttribute('data-product_variation') || '';
      const quantity = item.querySelector('.counter__input').value;
      products.push({
        productID,
        quantity,
        productVariation,
      });
    });
    return products;
  };

  if (cartModule) {
    const action = 'updateCheckoutTotalOnCart';
    const cartNonce = await getNonceForAction(action);
    const debounceTimer = 300;
    const updateTotalsOnPage = async (nonce, actionInner) => {
      const products = await updateProducts();
      const newTotals = await updateItemsQuantityInCart(products, cartNonce, actionInner);
      if (newTotals) {
        const paymentBox = cartModule.querySelector('.payment-box');
        const cartTotal = paymentBox.querySelectorAll('.payment-box__amount');
        cartTotal[0].innerHTML = `${newTotals.totalExcludingTax} €`;
        cartTotal[1].innerHTML = `${newTotals.total} €`;
        if (newTotals.refresh) {
          location.reload();
        }
      }
      const headerNonce = await getNonceForAction('profile_dropdown');
      axiosProfileData(headerNonce);
    };

    attachEvent(
      '.cart-module .counter__button-increment',
      'click',
      debounce(() => {
        updateTotalsOnPage(cartNonce, action);
      }, debounceTimer),
    );

    attachEvent(
      '.cart-module .counter__button-decrement',
      'click',
      debounce(() => {
        updateTotalsOnPage(cartNonce, action);
      }, debounceTimer),
    );
    attachEvent(
      'input.counter__input',
      'input',
      debounce(() => {
        updateTotalsOnPage(cartNonce, action);
      }, debounceTimer),
    );

    // Delete Item
    attachEvent(
      '.cart-product-list__delete',
      'click',
      debounce(async (e) => {
        const product = e.target.closest('.cart-product-list__row');
        const productID = product.dataset.product_id;
        const variationID = product.dataset.product_variation || 0;
        const quantity = product.querySelector('input').value;
        const products = [];
        products.push({
          productID,
          variationID,
          quantity,
        });

        await axiosRemoveItmesFromCart(products, cartNonce, action);
        updateTotalsOnPage(cartNonce, action);
      }, debounceTimer),
    );
  }
});
